/*********************************************************************************
 * Created Date: Tuesday Febuary 15th 2022                                       *
 * Author: Jan A.                                                                *
 * -----                                                                         *
 * Last Modified: Tue Feb 15 2022                                                *
 * Modified By: Jan A.                                                           *
 * -----                                                                         *
 * File: /src/components/account/Users/components/FormDialog/ValidationSchema.js *
 * Copyright (c) 2021 Kuva                                                       *
 *********************************************************************************/

import * as yup from "yup";

const ValidationSchema = yup.object({
  name: yup.string().required("Name is required"),
  email: yup
    .string()
    .email("Invalid email format")
    .required("Email is required"),
  roles: yup.string().required("Role is required")
});

export default ValidationSchema;
